import { render, staticRenderFns } from "./TabelaTipoRelatorioUsuario.vue?vue&type=template&id=e57546de&"
import script from "./TabelaTipoRelatorioUsuario.vue?vue&type=script&lang=js&"
export * from "./TabelaTipoRelatorioUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TabelaTipoRelatorioUsuario.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports